// @flow

import * as React from 'react';
import Group from 'sail/Group';
import {Caption} from 'sail/Text';
import type {Article} from 'docs/data';
import {XRaySidebarSection} from './XRaySidebarSection';
import {ConditionsListItems} from './ConditionsListItems';

type ConditionsListProps = {|
  article: Article,
|};

const FLAGS_TO_IGNORE = ['use_cached_docs', 'markdoc_show_localized_doc'];
const CORE_CONDITIONS = ['stripe_employee', 'country', 'user_logged_in'];

export const ConditionsList = ({article}: ConditionsListProps) => {
  if (!article.xray || !article.xray.conditions) {
    console.warn('Missing necessary x-ray data. Please contact #docs-product!'); // eslint-disable-line no-console
    return null;
  }

  const conditions = article.xray.conditions;
  const pageConditions = [...conditions.affirmative, ...conditions.negative];

  const flagConditions = [];
  const gateConditions = [];
  const coreConditions = [];
  const contribConditions = [];

  pageConditions.forEach((c) => {
    if (c.valid) {
      if (!FLAGS_TO_IGNORE.includes(c.name) && c.type === 'flag') {
        flagConditions.push(c);
      } else if (c.type === 'gate') {
        gateConditions.push(c);
      } else if (CORE_CONDITIONS.includes(c.type)) {
        coreConditions.push(c);
      } else {
        contribConditions.push(c);
      }
    }
  });

  let content;
  if (pageConditions.length === 0) {
    content = <Caption>None</Caption>;
  } else {
    content = (
      <Group spacing={4}>
        <ConditionsListItems
          type="flag"
          keys={flagConditions.map((f) => f.name)}
          article={article}
        />
        <ConditionsListItems
          type="gate"
          keys={gateConditions.map((f) => f.name)}
          article={article}
        />
        <ConditionsListItems
          type="core"
          // for custom conditions their name is the description so need type instead
          keys={coreConditions.map((f) => f.type)}
          article={article}
        />
        <ConditionsListItems
          type="contrib"
          // for custom conditions their name is the description so need type instead
          keys={contribConditions.map((f) => f.type)}
          article={article}
        />
      </Group>
    );
  }

  return (
    <XRaySidebarSection
      title="Conditions to View This Page"
      hint="These are the conditions that must be true in order to view this page. By default, conditions are set to true on Stripe machines."
    >
      <Group spacing={4}>{content}</Group>
    </XRaySidebarSection>
  );
};
